// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-light: #1344bc;
    --primary: #0A2463;
    --primary-dark: #06173f;

    --secondary-light: #96ce96;
    --secondary: #62B662;
    --secondary-dark: #499c49;

    --white: #FFFFFF;
    --greyLight-1: #E4EBF5;
    --greyLight-2: #6a6666;
    --greyLight-3: #bec8e4;
    --greyDark: #9baacf;
    --black: #000;
    --shadow: 0rem 0rem 0rem .2rem var(--greyLight-2),
        0rem 0rem .6rem .2rem var(--black);
    --shadow-secondary: 0rem 0rem 0.3rem .5rem #0f3f79,
        -.2rem -.4rem 1.6rem #93c4ff;
    ;


}
.arrow {
  box-sizing: border-box;
  height: 1vw;
  width: 1vw;
  border-style: solid;
  border-color: white;
  border-width: 0px 1px 1px 0px;
  transform: rotate(45deg);
  transition: border-width 150ms ease-in-out;
  margin-left: 5vh;
  padding: 2px 0;
}

.arrow:hover {
  border-bottom-width: 4px;
  border-right-width: 4px;
}

.btn {
    width: 15rem;
    height: 3rem;
    border-radius: 1.5rem;
    box-shadow: .3rem .3rem .6rem var(--greyLight-2),
        -.2rem -.2rem .5rem var(--white);
    ;
    justify-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: .3s ease;

}
.btn__primary {
    grid-column: 1 / 2;
    grid-row: 4 / 5;
    background: var(--primary);
    box-shadow: inset .2rem .2rem 1rem var(--primary-light),
        inset -.2rem -.2rem 1rem var(--primary-dark),
        var(--shadow);
    color: var(--greyLight-1);
}

.btn__primary1 {
    grid-column: 1 / 2;
    grid-row: 4 / 5;
    background: var(--greyLight-2);
    box-shadow: inset .2rem .2rem 1rem var(--greyLight-3),
        inset -.2rem -.2rem 1rem var(--primary-dark),
        var(--shadow);
    color: var(--primary);
}

.btn__primary2 {
    grid-column: 1 / 2;
    grid-row: 4 / 5;
    background: var(--greyLight-1);
    box-shadow: inset .2rem .2rem 1rem var(--primary-light),
        inset -.2rem -.2rem 1rem var(--greyDark),
        var(--shadow);
    color: var(--primary);
}

.btn__secondary {
    width: 15rem;
    height: 4vh;
    margin: auto;
    border-radius: 2vh;
    grid-column: 1 / 2;
    grid-row: 4 / 5;
    background: var(--secondary);
    box-shadow: inset .2rem .2rem 1rem var(--secondary-light),
        inset -.2rem -.2rem 1rem var(--secondary-dark),
        var(--shadow-secondary);
    color: white;
    padding: 0.4vh 1.4vw; 
    text-transform: capitalize; 
    font-size: 1.1vw
}




.btn:hover {
    color: var(--white);
}

.btn:active {
    color: var(--white);
}

.btnColor1 {
    color: #2F55AF;
}

.btnColor2 {
    color: #0C95BA;
}

.btnColor3 {
    color: #10054D;
}

.btnColor4 {
    color: #3AB9D6;
}

.btnColor5 {
    color: #000000;
}

.btnColor6 {
    color: #131B23;
}

.btnColor7 {
    color: #DBDBDB;
}

.btnColor8 {
    color: #E9EEF3;
}

.btnColor9 {
    color: #0E6495;
}

.btnColor10 {
    color: #0E6495;
}

.btnColor11 {
    color: #0F3F79;
}

.btnColor12 {
    color: #25054D;
}

.btnColor13 {
    color: #42B6D6;
}

.btnColor14 {
    color: #DC3545;
}

.btnColor15 {
    color: #666666;
}

.btnColor16 {
    color: #62B662;
}

.btnColor17 {
    color: #C4C4C4;
}

.btnColor18 {
    color: #92E7FF;
}

.btnColor19 {
    color: #99FBFF;
}

.btnColor20 {
    color: #0D95BB;
}

.btnColor21 {
    color: #CCCCCC;
}

.btnColor22 {
    color: #D9D9D9;
}

.btnColor23 {
    color: #EE4057;
}

.btnColor24 {
    color: #359FAF;
}

.btnColor25 {
    color: #D443A2;
}

.btnColor26 {
    color: #7121FF;
}`, "",{"version":3,"sources":["webpack://./src/styles/btn.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,uBAAuB;;IAEvB,0BAA0B;IAC1B,oBAAoB;IACpB,yBAAyB;;IAEzB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb;0CACsC;IACtC;oCACgC;;;;AAIpC;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;EACxB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB;wCACoC;;IAEpC,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;;AAExB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B;;qBAEiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B;;qBAEiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B;;qBAEiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B;;+BAE2B;IAC3B,YAAY;IACZ,oBAAoB;IACpB,0BAA0B;IAC1B;AACJ;;;;;AAKA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[":root {\n    --primary-light: #1344bc;\n    --primary: #0A2463;\n    --primary-dark: #06173f;\n\n    --secondary-light: #96ce96;\n    --secondary: #62B662;\n    --secondary-dark: #499c49;\n\n    --white: #FFFFFF;\n    --greyLight-1: #E4EBF5;\n    --greyLight-2: #6a6666;\n    --greyLight-3: #bec8e4;\n    --greyDark: #9baacf;\n    --black: #000;\n    --shadow: 0rem 0rem 0rem .2rem var(--greyLight-2),\n        0rem 0rem .6rem .2rem var(--black);\n    --shadow-secondary: 0rem 0rem 0.3rem .5rem #0f3f79,\n        -.2rem -.4rem 1.6rem #93c4ff;\n    ;\n\n\n}\n.arrow {\n  box-sizing: border-box;\n  height: 1vw;\n  width: 1vw;\n  border-style: solid;\n  border-color: white;\n  border-width: 0px 1px 1px 0px;\n  transform: rotate(45deg);\n  transition: border-width 150ms ease-in-out;\n  margin-left: 5vh;\n  padding: 2px 0;\n}\n\n.arrow:hover {\n  border-bottom-width: 4px;\n  border-right-width: 4px;\n}\n\n.btn {\n    width: 15rem;\n    height: 3rem;\n    border-radius: 1.5rem;\n    box-shadow: .3rem .3rem .6rem var(--greyLight-2),\n        -.2rem -.2rem .5rem var(--white);\n    ;\n    justify-self: center;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: .3s ease;\n\n}\n.btn__primary {\n    grid-column: 1 / 2;\n    grid-row: 4 / 5;\n    background: var(--primary);\n    box-shadow: inset .2rem .2rem 1rem var(--primary-light),\n        inset -.2rem -.2rem 1rem var(--primary-dark),\n        var(--shadow);\n    color: var(--greyLight-1);\n}\n\n.btn__primary1 {\n    grid-column: 1 / 2;\n    grid-row: 4 / 5;\n    background: var(--greyLight-2);\n    box-shadow: inset .2rem .2rem 1rem var(--greyLight-3),\n        inset -.2rem -.2rem 1rem var(--primary-dark),\n        var(--shadow);\n    color: var(--primary);\n}\n\n.btn__primary2 {\n    grid-column: 1 / 2;\n    grid-row: 4 / 5;\n    background: var(--greyLight-1);\n    box-shadow: inset .2rem .2rem 1rem var(--primary-light),\n        inset -.2rem -.2rem 1rem var(--greyDark),\n        var(--shadow);\n    color: var(--primary);\n}\n\n.btn__secondary {\n    width: 15rem;\n    height: 4vh;\n    margin: auto;\n    border-radius: 2vh;\n    grid-column: 1 / 2;\n    grid-row: 4 / 5;\n    background: var(--secondary);\n    box-shadow: inset .2rem .2rem 1rem var(--secondary-light),\n        inset -.2rem -.2rem 1rem var(--secondary-dark),\n        var(--shadow-secondary);\n    color: white;\n    padding: 0.4vh 1.4vw; \n    text-transform: capitalize; \n    font-size: 1.1vw\n}\n\n\n\n\n.btn:hover {\n    color: var(--white);\n}\n\n.btn:active {\n    color: var(--white);\n}\n\n.btnColor1 {\n    color: #2F55AF;\n}\n\n.btnColor2 {\n    color: #0C95BA;\n}\n\n.btnColor3 {\n    color: #10054D;\n}\n\n.btnColor4 {\n    color: #3AB9D6;\n}\n\n.btnColor5 {\n    color: #000000;\n}\n\n.btnColor6 {\n    color: #131B23;\n}\n\n.btnColor7 {\n    color: #DBDBDB;\n}\n\n.btnColor8 {\n    color: #E9EEF3;\n}\n\n.btnColor9 {\n    color: #0E6495;\n}\n\n.btnColor10 {\n    color: #0E6495;\n}\n\n.btnColor11 {\n    color: #0F3F79;\n}\n\n.btnColor12 {\n    color: #25054D;\n}\n\n.btnColor13 {\n    color: #42B6D6;\n}\n\n.btnColor14 {\n    color: #DC3545;\n}\n\n.btnColor15 {\n    color: #666666;\n}\n\n.btnColor16 {\n    color: #62B662;\n}\n\n.btnColor17 {\n    color: #C4C4C4;\n}\n\n.btnColor18 {\n    color: #92E7FF;\n}\n\n.btnColor19 {\n    color: #99FBFF;\n}\n\n.btnColor20 {\n    color: #0D95BB;\n}\n\n.btnColor21 {\n    color: #CCCCCC;\n}\n\n.btnColor22 {\n    color: #D9D9D9;\n}\n\n.btnColor23 {\n    color: #EE4057;\n}\n\n.btnColor24 {\n    color: #359FAF;\n}\n\n.btnColor25 {\n    color: #D443A2;\n}\n\n.btnColor26 {\n    color: #7121FF;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
